import { apiClient } from './api';
import type { PopularPodcastDetail, PodcastEpisodeWithProjectCount } from '../types/api.types';

export const metricsService = {
  // Get popular podcasts filtered by language
  getPopularPodcastsByLanguage: async (language: string): Promise<PopularPodcastDetail[]> => {
    const { data } = await apiClient.get<PopularPodcastDetail[]>(
      `/metrics/popular/podcasts/${language}`
    );
    return data;
  },

  // Get available podcast languages from database
  getAvailableLanguages: async (): Promise<string[]> => {
    const { data } = await apiClient.get<string[]>('/metrics/podcast/languages');
    return data;
  },

  // Get local podcast episodes (already in database) with project counts
  getLocalPodcastEpisodes: async (podcastUuid: string): Promise<PodcastEpisodeWithProjectCount[]> => {
    const { data } = await apiClient.get<PodcastEpisodeWithProjectCount[]>(
      `/metrics/podcast/episodes/${podcastUuid}`
    );
    return data;
  },
};
